// Free gift ("The Way of Tea" ebook) auto-add, see snippets/free-gift-config.liquid.
//
// The gift is its own $0 product ("The Way of Tea — Free Gift"); nothing is
// discounted. The paid ebook is a different product and is never touched.
//
// Rules:
// - At least one eligible line (anything except excluded titles, i.e. neither
//   ebook nor Shipping Protection) and no gift or paid-ebook line -> add the
//   gift variant once with _gift: "true".
// - No eligible lines left -> remove the gift variant line (with or without
//   _gift). The paid ebook is never removed.
// - If the customer removes the gift themselves, remember it in the cart
//   attribute _gift_declined and never re-add it for this cart.
//
// Runs on page load, on Dawn's cartUpdate event (product form, drawer and cart
// page quantity changes) and after the cart upsell adds its item. Changes are
// serialized and capped so it can never loop or add twice.
(function () {
  if (window.freeGiftBound) return;
  var configEl = document.getElementById('FreeGiftConfig');
  if (!configEl) return;
  window.freeGiftBound = true;

  var config = JSON.parse(configEl.textContent);
  var excluded = (config.excludeTitles || [])
    .map(function (title) {
      return String(title).trim().toLowerCase();
    })
    .filter(Boolean);
  var DECLINED_ATTRIBUTE = '_gift_declined';
  var MAX_CHANGES_PER_TRIGGER = 3;

  var declinedLocally = false;
  var addFailed = false;
  var running = false;
  var rerunRequested = false;
  var changesThisTrigger = 0;

  function isGiftLine(item) {
    return item.variant_id === config.variantId;
  }

  function isPaidEbookLine(item) {
    return config.paidProductId != null && item.product_id === config.paidProductId;
  }

  function isEligibleLine(item) {
    if (isGiftLine(item) || isPaidEbookLine(item) || item.product_id === config.productId) return false;
    var title = String(item.product_title || '').toLowerCase();
    return !excluded.some(function (excludedTitle) {
      return title.indexOf(excludedTitle) !== -1;
    });
  }

  // The cart page re-renders through <cart-items>, the drawer through
  // <cart-drawer-items>; both expose Dawn's getSectionsToRender().
  function cartComponent() {
    return document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
  }

  function renderSections(state, component) {
    if (!component || !state.sections) return;
    component.getSectionsToRender().forEach(function (section) {
      var host = document.getElementById(section.id);
      var html = state.sections[section.section];
      if (!host || !html) return;
      var target = host.querySelector(section.selector) || host;
      var source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
      if (source) target.innerHTML = source.innerHTML;
    });
  }

  function toggleEmpty(itemCount) {
    if (typeof itemCount !== 'number') return;
    var isEmpty = itemCount === 0;
    ['cart-drawer', 'cart-drawer-items', 'cart-items', '#main-cart-footer'].forEach(function (selector) {
      var element = document.querySelector(selector);
      if (element) element.classList.toggle('is-empty', isEmpty);
    });
  }

  function postCart(url, body) {
    var component = cartComponent();
    var sections = component && component.getSectionsToRender ? component.getSectionsToRender() : [];
    body.sections = sections.map(function (section) {
      return section.section;
    });
    body.sections_url = window.location.pathname;

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json().then(function (json) {
          return { ok: response.ok && !json.status, json: json };
        });
      })
      .then(function (result) {
        if (result.ok) {
          renderSections(result.json, component);
          toggleEmpty(result.json.item_count);
        }
        return result;
      });
  }

  function nextChange(cart) {
    var declined =
      declinedLocally || (cart.attributes && cart.attributes[DECLINED_ATTRIBUTE] === 'true');
    var eligible = cart.items.some(isEligibleLine);
    var giftLines = cart.items.filter(isGiftLine);
    var hasEbookLine = giftLines.length > 0 || cart.items.some(isPaidEbookLine);

    if (!eligible && giftLines.length) {
      return function () {
        return postCart(window.routes.cart_change_url + '.js', { id: giftLines[0].key, quantity: 0 });
      };
    }
    if (eligible && giftLines.length && giftLines[0].quantity > 1) {
      return function () {
        return postCart(window.routes.cart_change_url + '.js', { id: giftLines[0].key, quantity: 1 });
      };
    }
    if (eligible && !hasEbookLine && !declined && !addFailed) {
      return function () {
        return postCart(window.routes.cart_add_url + '.js', {
          items: [{ id: config.variantId, quantity: 1, properties: { _gift: 'true' } }],
        }).then(function (result) {
          if (!result.ok) addFailed = true;
          return result;
        });
      };
    }
    return null;
  }

  function check() {
    if (running) {
      rerunRequested = true;
      return;
    }
    running = true;

    fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var change = nextChange(cart);
        if (!change || changesThisTrigger >= MAX_CHANGES_PER_TRIGGER) return;
        changesThisTrigger += 1;
        return change().then(function (result) {
          // Verify the result once more (e.g. several gift lines to clean up).
          if (result.ok) rerunRequested = true;
        });
      })
      .catch(function () {})
      .then(function () {
        running = false;
        if (rerunRequested) {
          rerunRequested = false;
          check();
        }
      });
  }

  function onCartChanged() {
    changesThisTrigger = 0;
    check();
  }

  // Customer removes the gift line themselves -> never re-add for this cart.
  document.addEventListener(
    'click',
    function (evt) {
      var removeButton = evt.target.closest('cart-remove-button');
      if (!removeButton || !removeButton.closest('[data-gift-line]')) return;
      declinedLocally = true;
      var attributes = {};
      attributes[DECLINED_ATTRIBUTE] = 'true';
      fetch(window.routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attributes }),
      }).catch(function () {});
    },
    true
  );

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartChanged);
  }
  document.addEventListener('cart-upsell:added', onCartChanged);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onCartChanged);
  } else {
    onCartChanged();
  }
})();
